import React from 'react';

import HomeSection from '../../sections/HomeSection';

const HomeModule = () => (
  <div><HomeSection /></div>
);

export default HomeModule;
